import Vue from 'vue'
import Router from 'vue-router'
import AccountHome from '@/pages/account/home'
import AccountOrders from '@/pages/account/orders'
import AccountOrderInvoice from '@/pages/account/invoice'
import AccountCommission from '@/pages/account/commission'
import AccountNewLogin from '@/pages/account/newLogin'
import Settlement from '@/pages/account/settlement'
import Withdraw from '@/pages/account/withdraw'
import WithdrawLock from '@/pages/account/withdrawLock'
import WithdrawList from '@/pages/account/withdrawList'
import WithdrawSettlement from '@/pages/account/withdrawSettlement'
import ActivityHome from '@/pages/activity/home'
import QuestionColumn from '@/pages/activity/questionColumn'
import QuestionAnswer from '@/pages/activity/questionAnswer'
import Province from '@/pages/activity/province'
import City from '@/pages/activity/city'
import ActivityDetail from '@/pages/activity/detail'
import Protocal from '@/pages/account/protocal'
import Products from '@/pages/activity/products'
import ProductDetail from '@/pages/activity/productDetail'
import CertificateHome from '@/pages/certificate/home'
import CertificateInsure from '@/pages/certificate/insure'
import CertificateOwner from '@/pages/certificate/owner'
import CertificateAgreement from '@/pages/certificate/agreement'
import RedPacket from '@/pages/subject/redpacket/index'
import SwapDiscount from '@/pages/activity/swapDiscount'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      redirect: '/activity/home',
    },
    {
      path: '/account',
      name: 'AccountHome',
      component: AccountHome
    },
    {
      path: '/account/order',
      name: 'AccountOrders',
      component: AccountOrders
    },
    {
      path: '/account/swipOrder',
      name: 'AccountSwipOrders',
      component: () => import('@/pages/account/swipOrders.vue')
    },
    {
      path: '/account/order/invoice/:orderId',
      name: 'AccountOrderInvoice',
      component: AccountOrderInvoice
    },
    {
      path: '/account/commission',
      name: 'AccountCommission',
      component: AccountCommission
    },
    {
      path: '/account/settlement',
      name: 'Settlement',
      component: Settlement
    },
    {
      path: '/account/withdraw',
      name: 'Withdraw',
      component: Withdraw
    },
    {
      path: '/account/withdrawLock',
      name: 'WithdrawLock',
      component: WithdrawLock
    },
    {
      path: '/account/withdrawList',
      name: 'WithdrawList',
      component: WithdrawList
    },
    {
      path: '/account/withdrawSettlement',
      name: 'WithdrawSettlement',
      component: WithdrawSettlement
    },
    {
      path: '/account/login',
      name: 'AccountNewLogin',
      component: AccountNewLogin,
      meta: { auth: false }
    },
    {
      path: '/activity/home',
      name: 'ActivityHome',
      component: ActivityHome
    },
    {
      path: '/activity/detail/:platformActivityId',
      name: 'ActivityDetail',
      component: ActivityDetail
    },
    {
      path: '/activity/questionColumn',
      name: 'QuestionColumn',
      component: QuestionColumn
    },
    {
      path: '/activity/questionAnswer/:id?',
      name: 'QuestionAnswer',
      component: QuestionAnswer
    },
    {
      path: '/activity/swapDiscount',
      name: 'SwapDiscount',
      component: SwapDiscount,
      meta: { auth: false }
    },
    {
      path: '/province',
      name: 'Province',
      component: Province
    },
    {
      path: '/city',
      name: 'City',
      component: City
    },
    {
      path: '/account/protocal',
      name: 'Protocal',
      component: Protocal,
      meta: { auth: false }
    },
    {
      path: '/account/invitational',
      name: 'Invitational',
      component: () => import('@/pages/account/invitational.vue')
    },
    {
      path: '/products',
      name: 'Products',
      component: Products
    },
    {
      path: '/product/detail/:productId',
      name: 'ProductDetail',
      component: ProductDetail
    },
    {
      path: '/certificate/home',
      name: 'CertificateHome',
      component: CertificateHome
    },
    {
      path: '/certificate/insure',
      name: 'CertificateInsure',
      component: CertificateInsure
    },
    {
      path: '/certificate/owner',
      name: 'CertificateOwner',
      component: CertificateOwner
    },
    {
      path: '/certificate/agreement',
      name: 'CertificateAgreement',
      component: CertificateAgreement
    },
    {
      path: '/redpacket',
      name: 'RedPacket',
      component: RedPacket,
      meta: { auth: false }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js